import $ from 'jquery'
import User from '../../store/User'
import Group from '../../store/Group'
import messageResource from '../../messageResource'
import BaseUsersSelector from '../../controls/BaseUsersSelector'

function CopyUserSettingsSelector()
{

}

CopyUserSettingsSelector.prototype = new BaseUsersSelector();

/**
 * Initializes users selector
 * @param allGroups
 * @param allUsers
 * @param onSelectCallback - function( selectedUserId )
 * @param selectedUserId
 */
CopyUserSettingsSelector.prototype.init = function( allGroups, allUsers, onSelectCallback, selectedUserId, ugrEnabled, tzgEnabled )
{
    this.onSelectCallback = onSelectCallback;
    var self = this;
    this.clean();
    var users = [];
    var groups;

    $.each( allUsers, function() {
        users.push( new User( this.id, this.firstName, this.lastName, this.middleInitial, this.username, this.enabled, this.emailExists, this.userGroupId, this.timeZoneGroupId ) );
    });

    if ( allGroups )
    {
        groups = [];

        $.each( allGroups, function() {
            groups.push( new Group( this.id, this.name) );
        });
    }

    this.onUserSelect = function( selectedUserId )
    {
        self.disableInput();
        if ( self.onSelectCallback )
            self.onSelectCallback( selectedUserId );
    };

    var emptyValue = '';
    var initialValue = selectedUserId ? selectedUserId : emptyValue;

    var baseInit = function()
    {
        BaseUsersSelector.prototype.init.call( self, users, groups, initialValue, emptyValue, null, 158, "copy-user-settings-from-list", ugrEnabled, tzgEnabled );
        self.input = $( "#" + self.elementId + " input" );
        self.input.attr("maxlength", "400");
        self.input.attr("placeholder", messageResource.getMessage("user.add.js.copy_settings_from") ).placeholder();
        self.input.addClass("inputFieldWithPlaceholder");

        self.usersCombo.on("blur", function() {
            if ( self.input.pVal() == '' )
                self.usersCombo.setValue( self.initialValue );

            self.input.pVal( self.input.pVal() );
        });
    };

    this.removeUser = function( userId )
    {
        this.clean();

        var newUsers = [];
        $.each( users, function()
        {
            if ( this.id != userId )
                newUsers.push( this );
        });
        users = newUsers;

        baseInit();
    };

    baseInit();

    this.disableInput = function()
    {
        self.input.focus( function() { this.blur(); } );
    };

    this.enableInput = function()
    {
        self.input.off( "focus" );
    };
};

CopyUserSettingsSelector.prototype.clean = function()
{
    $( "#" + this.elementId ).empty();
};

export default CopyUserSettingsSelector



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/CopyUserSettingsSelector.js